export default function noSpecialChar() {
  return this.test('noSpecialChar', 'noSpecialCharactersMatches', (value) =>
    `${value}`.match(/^[0-9a-zA-Z]+$/),
  )
}
